import { render, staticRenderFns } from "./AgentProduct.vue?vue&type=template&id=45768881"
import script from "./AgentProduct.vue?vue&type=script&lang=js"
export * from "./AgentProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports